<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-6">
      <h1 class="text-center">Panel de Configuración</h1>
      <h1>Ordenes</h1>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header class="border-0">
              <button type="button"
                      class="btn btn-primary px-4"
                      @click="downloadExcel">
                Descargar Excel
              </button>
            </b-card-header>

            <multiselect
                  :show-labels="false"
                  v-model="hospitalList"
                  :options="hospitals"
                  class="mb-4"
                  :multiple="true"
                  placeholder='Selecciona el hospital a visualizar'
                  label="name"
                  track-by="id"
                  value-prop="id"
                  style="max-width: 350px; margin-left: 20px;"
                  >
            </multiselect>

            <base-input
                      type="text"
                      placeholder="Buscar"
                      v-model="search"
                      style="max-width: 300px !important; margin-left: 20px;"
                    >
                    </base-input>

            <el-table class="table-responsive table"
                      header-row-class-name="thead-light"
                      @row-click="showModalOrder"
                      :data="pagedTableData">
                <el-table-column label="No. Orden"
                          prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                          <router-link
                            :to="{
                              name: 'ordenesEdit',
                              params: { orderId: row.id },
                            }">
                                {{row.id}}
                            </router-link>
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="# Colaborador"
                          prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.collaborator_number}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Nombre"
                          prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.name}} {{row.first_lastname}} {{row.second_lastname}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Hospital"
                          prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.hospital}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Especialidad"
                          prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.specialty}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label="Fecha"
                          prop="name">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                            {{row.date}}
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label=""
                          prop=""
                          width="80px"
                          style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                          <router-link
                            :to="{
                              name: 'ordenesEdit',
                              params: { orderId: row.id },
                            }">
                                <img src="img/theme/icn_edit.svg" alt="">
                            </router-link>
                        </b-media>
                    </template>
                </el-table-column>
                <el-table-column label=""
                          prop=""
                          width="80px"
                          style="padding-left: 0.5rem !important; padding-right: 0.5rem !important;"
                          >
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center">
                          <a class="page-link" @click="deleteElement(row.id)"><img src="img/theme/icn_delete.svg" alt=""></a>
                        </b-media>
                    </template>
                </el-table-column>
            </el-table>
            <b-card-footer class="py-4 d-flex justify-content-end">
                <base-pagination v-model="currentPage" :per-page="10" @change="setPage"  :total="orders.length"></base-pagination>
            </b-card-footer>
        </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import Multiselect from 'vue-multiselect'
  import axios from 'axios'
  import qs from 'qs'
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';

  export default {
    data() {
      return {
        orders: [],
        hospitals: [],
        hospitalList: '',
        token:'',
        user:'',
        currentPage: 1,
        pageSize: 10,
        search: ''
      };
    },
    components: {
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Multiselect,
    },
    async created () {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')
      await axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
        qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_orders'}),
      )
      .then((response) => {
        if (!response.data.error.code && response.data.orders) {
          let temp = []
          Object.keys(response.data.orders).map((key) => [response.data.orders[key]]).map(function(value) {
              temp.push(value[0])
          })
          this.orders = temp
        }
      })
      .catch((err) => {
        console.log(err)
      })

      await axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_catalogs'}),
      )
      .then((response) => {
        if (!response.data.error.code && response.data.hospitals) {
          let temp = []
          Object.keys(response.data.hospitals).map((key) => [response.data.hospitals[key]]).map(function(value) {
              temp.push(value[0])
          })
          this.hospitals = temp
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    computed: {
      pagedTableData() {
        let filteredH
        if(this.hospitalList.length>0){
          filteredH = this.hospitalList.map(z => z.id)
        }

        return this.orders.filter(data => this.hospitalList.length ? filteredH.includes(data.id_hospital): data).filter(data => this.search ? data.id == this.search || data.collaborator_number == this.search : data).slice(this.pageSize * this.currentPage - this.pageSize, this.pageSize * this.currentPage)
      }
    },
    methods : {
      setPage (val) {
        this.currentPage = val
      },
      showModalOrder (index) {
        console.log(index)
      },
      async downloadExcel (){
        this.token = localStorage.getItem('token')
        this.user = localStorage.getItem('id_user')

        let formData = new FormData()
        formData.append('user_id', this.user)
        formData.append('api_token', this.token)
        if(this.hospitalList.length>0)
          formData.append('id_hospital', this.hospitalList.map(z => z.id))

        await axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'db_to_xlsx.php', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          responseType: 'arraybuffer',
        })
        .then(response => {
            let blob = new Blob([response.data], { type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'ordenes.xlsx'
            link.click()
            window.URL.revokeObjectURL(blob)
        })
        .catch(err => {
            console.log(err)
        })
      },
      deleteElement(index){
        this.token = localStorage.getItem('token')
        this.user = localStorage.getItem('id_user')
        var position = this.orders.findIndex(x => x.id === index)
        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
          qs.stringify({
            api_token: this.token,
            user_id: this.user,
            option: 'delete_order',
            o_id: index}),
        )
        .then((response) => {
          if (!response.data.error.code) {
            this.reload++
            this.orders.splice(position, 1)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      }
    }
  };
</script>
<style>
.el-table, a{
  color: #112357;
}
</style>
